/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  SvgIcon
} from '../'

export const Warning = ({ children, inline, iconSize, iconMargin, title, className }) => {
  let icon = <SvgIcon
    variant='utility'
    symbol='warning'
    colour='error'
    size={iconSize}
    title={title}
    className={`slds-m-right_${iconMargin}`}
  />

  if (inline) {
    return (
      <React.Fragment>
        {icon}
        {children}
      </React.Fragment>
    )
  } else {
    return (
      <div className={`slds-grid ${className}`} style={{ alignItems: 'center' }}>
        {icon}
        {children}
      </div>
    )
  }
}

Warning.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  inline: PropTypes.bool,  // pass in 'true' if component used inside an existing grid layout or outer jsx element
  iconSize: PropTypes.oneOf(['x-small', 'small', 'medium', 'large', 'x-large']),
  iconMargin: PropTypes.oneOf(['x-small', 'small', 'medium', 'large', 'x-large']),  // margin size between icon and text/element that follows
  className: PropTypes.string
}

Warning.defaultProps = {
  inline: false,
  iconSize: 'small',
  iconMargin: 'x-small',
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/warning/index.js